module.exports = __webpack_public_path__ + "img/stock-02.beb75e9.jpg";